import { NgModule } from '@angular/core';
import { DoctorLeadComponent } from './doctor-lead/doctor-lead.component';
import { SharedModule } from '@app/shared-module/shared-module.module';
import { SubscriptionListComponent } from './subscription-list/subscription-list.component';
import { AdminService } from '@app/services/admin.service';
import { UpdateDoctorLeadDialogComponent } from './update-doctor-lead/update-doctor-lead.component';
import { ViewDoctorLeadDialogComponent } from './view-doctor-lead/view-doctor-lead.component';
import { DoctorRoutingModule } from './doctor-routing.module';
import { ViewDoctorSubscriptionDialogComponent } from './view-doctor-subscription/view-doctor-subscription.component';
import { UpdateDoctorSubscriptionDialogComponent } from './update-doctor-subscription/update-doctor-subscription.component';
import { DatePipe } from '@angular/common';
import { UpdateMaxDoctorDialogComponent } from './update-max-doctor/update-max-doctor.component';
import { ActivateDoctorSubscriptionDialogComponent } from './activate-doctor-subscription/activate-doctor-subscription.component';
import { HardResetPasswordComponent } from '@app/admin-module/hard-reset-password/hard-reset-password.component';


@NgModule({
  declarations: [
    DoctorLeadComponent,
    SubscriptionListComponent,
    UpdateDoctorLeadDialogComponent,
    ViewDoctorLeadDialogComponent,
    ViewDoctorSubscriptionDialogComponent,
    UpdateMaxDoctorDialogComponent,
    UpdateDoctorSubscriptionDialogComponent,
    ActivateDoctorSubscriptionDialogComponent
  ],
  providers: [
    AdminService,
    DatePipe
  ],
  imports: [
    SharedModule,
    DoctorRoutingModule
  ],
  entryComponents: [
    UpdateDoctorLeadDialogComponent,
    ViewDoctorLeadDialogComponent,
    ViewDoctorSubscriptionDialogComponent,
    UpdateMaxDoctorDialogComponent,
    ActivateDoctorSubscriptionDialogComponent,
    UpdateDoctorSubscriptionDialogComponent,
    HardResetPasswordComponent
  ]
})
export class DoctorModule { }
